<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import Slider from '@lit-element/components/slider'
import VideoControl from './video-control.vue'

defineOptions({ name: 'VideoVolume' })

const props = defineProps({
  volume: {
    type: Number,
    default: 1,
  },
})

const emit = defineEmits(['change'])

const ns = useNamespace('video')

const currentVolume = ref(props.volume)
const muted = ref(false)

const volumeIcon = computed(() => {
  if (muted.value) {
    return 'https://image.whzb.com/chain/lit-element/js/img/volumeMute.png'
  } else if (currentVolume.value < 0.5) {
    return 'https://image.whzb.com/chain/lit-element/js/img/volumeLow.png'
  } else {
    return 'https://image.whzb.com/chain/lit-element/js/img/volume.png'
  }
})

watch(
  () => props.volume,
  (value) => {
    currentVolume.value = value
  }
)

defineExpose({ toggleMute })

let prevVolume = currentVolume.value

function toggleMute() {
  if (muted.value) {
    currentVolume.value = prevVolume <= 0 ? 0.5 : prevVolume
  } else {
    prevVolume = currentVolume.value
    currentVolume.value = 0
  }

  muted.value = !muted.value

  emit('change', currentVolume.value)
}

function handleSlide(value: any) {
  value /= 100
  prevVolume = value
  currentVolume.value = value
  muted.value = value <= 0
  emit('change', currentVolume.value)
}
</script>

<template>
  <VideoControl
    :class="ns.e('volume')"
    type="panel"
    :tip-class="ns.e('volume-panel')"
    @button-click="toggleMute"
  >
    <img :src="volumeIcon" alt="" style="width: 18px" />
    <template #panel>
      <div :class="ns.e('volume-text')">
        {{ (currentVolume * 100).toFixed() }}
      </div>
      <Slider
        :model-value="currentVolume * 100"
        :class="ns.e('volume-slider')"
        :min="0"
        :max="100"
        height="100px"
        vertical
        size="small"
        :show-tooltip="false"
        :range="false"
        @input="handleSlide"
      />
    </template>
  </VideoControl>
</template>
